module.exports = __webpack_public_path__ + "images/maskable_icon-72.63c8650831df631162e382fe6c8551b2.png";